<!-- التعميم يجب التنزيل والقراءة -->
<div id="contentToConvert" class="sidebar" style="padding:8px;width: 100%;"
    *ngIf="generalizationAndAlertsObj?.generalizationSerial && generalizationAndAlertsObj?.isReaded==false">
    <div class="container" style="text-align: center;margin-bottom: 25px;">
        <div class="title-tab-step text-center">
            <h4 style="padding: 15px;"> {{ 'HEADER' | translate }} : {{generalizationAndAlertsObj?.circularHeader}}
            </h4>
        </div>

    </div>

    <div class="container">
        <div class="title-tab-step" style="margin-bottom: 8px;">
            <h4 style="padding:8px;">{{generalizationAndAlertsObj?.circularBody}}</h4>
        </div>
    </div>
    <div class="container" style="margin-top: 8px;">
        <button (click)="readGeneralizationAndAlerts(generalizationAndAlertsObj)">Read</button>
        <a download="{{generalizationAndAlertsObj?.downloadFileName}}" href="assets/genandalerts/sample.pdf">Download</a>
    </div>

</div>



<!-- بعد تنزيل وقراءة التعميم  -->
<div *ngIf="(!generalizationAndAlertsObj?.generalizationSerial && !generalizationAndAlertsObj?.isReaded) ||
(generalizationAndAlertsObj?.generalizationSerial && generalizationAndAlertsObj?.isReaded==true)">
    <div *ngIf="displayFlag!=5">

        <div class="sidebar">
            <!--logo-->
            <!-- <div class="logo_div">
            <a class="text-white d-flex justify-content-center align-items-center" href="javascript:void(0);">
            <img src="../assets/images/logoo.png" alt="" />
            <div class="hosp_name mx-2">
                <span>{{branchNameAr}}
                <br/>{{branchNameEn}}
                </span>
            </div>
            </a>
        </div> -->
            <aside class="app-side">
                <div class="side-content">
                    <nav class="side-nav">
                        <ul class="metismenu" data-plugin="metismenu">

                            <!-- <li class="">
                                <a href="javascript:void(0);">
                                <span class="nav-icon">
                                    <i class="fa fa-home"></i>
                                </span>
                                <span class="nav-title">{{ 'DASHBOARD' | translate }}</span>
                                <span class="nav-tools">
    
                                </span>
                                </a>
                            </li> -->

                            <!----------- Name Of Heading Item In Main Navbar ------------------>
                            <li *ngFor="let module of rootModules"
                                (click)="flagChangeModule=true;onRootModuleClick(module)"
                                [ngClass]="{'active' : module.active}">
                                <a href="javascript:void(0);">
                                    <span class="nav-icon">
                                        <!-- <img src="../assets/layouts/layout4/img/icons/{{module.iconName}}.png" /> -->
                                        <i class="fas {{module.iconName}}"></i>
                                    </span>
                                    <span class="nav-title">
                                        {{ translate.currentLang == 'ar'? module.nameAr: module.nameEn}}
                                    </span>
                                    <span class="nav-tools">
                                        <i class="fa fa-fw arrow"></i>
                                    </span>
                                </a>

                                <!----------- Name Of Heading Item In Secondary Navbar ------------------>
                                <ul class="nav nav-sub collapse" [ngClass]="{'in' : module.active}">
                                    <li *ngFor="let subModule of subModules | arrayfilter: 'parentCode' : module.code"
                                        [ngClass]="{'active' : subModule.act}"
                                        (click)="flagChangeModule = true;getLinks($event ,subModule, 1 , 1 )">
                                        <a href="javascript:void(0);">
                                            <i class="fas fa-angle-left"></i>
                                            {{translate.currentLang == 'ar'? subModule.nameAr: subModule.nameEn}}
                                        </a>
                                    </li>
                                </ul>

                            </li>


                            <!----------- Name Of REPORTS Item In Main Navbar ------------------>
                            <li class="" (click)="ShowUserReports()">
                                <a href="javascript:void(0);">
                                    <span class="nav-icon"><i class="far fa-edit"></i></span>
                                    <span class="nav-title">{{ 'REPORTS' | translate }}</span>
                                    <span class="nav-tools"></span>
                                </a>
                            </li>

                        </ul>
                    </nav>
                </div>
            </aside>
            <!--- sidebar -->
        </div>
        <!--- sidebar -->
        <div class="container-area">
            <div class="home-links">
                <div class="row">
                    <div class="col-12 col-lg-4 " *ngFor="let linkType of linksTypesList">

                        <div class="links-container" *ngIf="linkType !=5 ">
                            <h5 class="title" style="justify-content: space-between;"
                                (click)="selectLinkType(linkType)">
                                <!-- <img src="../assets/layouts/layout4/img/icons/newicon{{linkType}}.png" /> -->
                                <i class="fab fa-accusoft" *ngIf="linkType ==1 "></i>
                                <i class="fas fa-address-book" *ngIf="linkType ==2 "></i>
                                <i class="fas fa-cog" *ngIf="linkType ==3 "></i>
                                <span> {{linkType | linkType:translate.currentLang}}</span>
                                <i class="fa fa-sort" style="float: left;
                                display: initial;
                                position: initial;
                                text-align: center;
                                margin-top: 10px;
                                cursor: pointer;
                            " (click)="filterCompByName(linkType)"></i>
                            </h5>
                            <div class="link-container-area">
                                <ul>
                                    <li *ngFor="let module of moduleLinksFilter | arrayfilter: 'compType' : linkType "
                                        [hidden]="module.hidden">
                                        <a (click)="onLinkClicked(module ,$event)"
                                            href="javascript:void(0);">{{translate.currentLang == 'ar'? module.nameAr:
                                            module.nameEn}}</a>
                                        <!--fav-active-->
                                        <a href="javascript:void(0);" (click)="onFavourite(module,1)"
                                            class="add-to-fav">
                                            <i [ngClass]="{'fav-active' : module.isFav }" class="fas fa-star"></i> </a>
                                    </li>

                                </ul>
                            </div>
                            <!--link-container-area-->
                        </div>
                        <!--links-container-->
                    </div>
                    <!--col-->
                </div>
                <!--row-->
            </div>
        </div>
    </div>

    <div id="newDesign" *ngIf="displayFlag==5">
        <div class="sidebar">
            <aside class="app-side-new">
                <div class="side-content">
                    <nav class="side-nav">
                        <ul class="metismenu" data-plugin="metismenu">
                            <li *ngFor="let module of rootModules; index as indx" (click)="onRootModuleClick(module)"
                                [placement]="translate.currentLang == 'ar'?'left': 'right'"
                                ngbTooltip="{{translate.currentLang == 'ar'? module.nameAr: module.nameEn}}"
                                [ngClass]="{'active' : module.active}">
                                <a href="javascript:void(0);">
                                    <span class="nav-icon">
                                        <img src="assets/layouts/layout4/img/icons/{{module.imagePath}}.png" />
                                        <!-- you can use font icons instaed of using img icons -->
                                        <!-- <span class="fas {{module.iconName}} root-icon-i"></span> -->
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
        <div class="container-area">
            <div class="content-side"
                [ngClass]="{'float-left': translate.currentLang == 'ar', 'float-right' : translate.currentLang != 'ar'}">
                <div class="jumbotron-fluid"
                    [ngClass]="{'jumbotron-ar': translate.currentLang == 'ar', 'jumbotron-en' : translate.currentLang != 'ar'}">
                    <div class="container-fluid">
                        <h2 class="display-5 font-weight-bold pb-2 text-pri-color">{{'DASHBOARDHELLO' | translate}}</h2>
                        <p class="lead text-secondary">{{'DASHBOARDDESC' | translate}}</p>
                    </div>
                </div>
                <div class="" style="margin-top: -55px;">
                    <div class="row mb-3 mx-1">
                        <!-- sub modules -->
                        <div class="col-5 pxs-1 px-4 sub-menu">
                            <div class="row">
                                <div class="col-6 col-sm-4 p-1 py-2" *ngFor="let subModule of subModules"
                                    (click)="getLinks($event, subModule, 1, 1)">
                                    <div class="card p-0 d-flex align-items-center justify-content-center module-card h-100 module-card1"
                                        [ngClass]="{'active' : subModule['act']}">
                                        <div class="card-body p-0">
                                            <span class="fas fa-home {{subModule.iconName}} module-font"></span>
                                            <h5 class="card-title text-secondary font-weight-bold">
                                                {{translate.currentLang == 'ar'? subModule.nameAr: subModule.nameEn}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- links -->
                        <div class="col-7 pxs-1">
                            <div class="card d-flex align-items-center justify-content-center module-card">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-12 col-xl-4 xs" style="margin-top: -25px;"
                                            *ngFor="let linkType of linksTypesList">

                                            <div class="links-container" *ngIf="linkType !=5 ">

                                                <h5 class="title">
                                                    <i class="fab fa-accusoft" *ngIf="linkType ==1 "></i>
                                                    <i class="fas fa-address-book" *ngIf="linkType ==2 "></i>
                                                    <i class="fas fa-cog" *ngIf="linkType ==3 "></i>
                                                    {{linkType | linkType:translate.currentLang}}
                                                </h5>

                                                <div class="link-container-area">
                                                    <ul>
                                                        <li *ngFor="let module of moduleLinks | arrayfilter: 'compType' : linkType "
                                                            [hidden]="module.hidden">

                                                            <a (click)="onLinkClicked(module ,$event)"
                                                                href="javascript:void(0);">
                                                                {{translate.currentLang == 'ar'? module.nameAr:
                                                                module.nameEn}}
                                                            </a>
                                                            <a href="javascript:void(0);"
                                                                (click)="onFavourite(module,1)" class="add-to-fav">
                                                                <i [ngClass]="{'fav-active' : module.isFav }"
                                                                    class="fas fa-star"></i>
                                                            </a>

                                                        </li>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>